export const AppConstants = {
    COURSE_IT: 'Information Technology',
    PRODUCT_NAME: 'Bachelor of Science in Interdisciplinary Studies',
};
